import { useState } from 'react'
import { useLocation } from 'wouter'
import { useQueryClient } from '@tanstack/react-query'
import {
  GoogleLogin as GoogleLoginButton,
  CredentialResponse,
} from '@react-oauth/google'

import { Spinner } from '@/components/Spinner'
import { api } from '@/utils/api'
import { getDevice } from '@/utils/getDevice'
import { useToast } from '@/hooks/Toast'

import s from './Login.module.css'

export const Login = () => {
  const [isLoading, setIsLoading] = useState(false)
  const queryClient = useQueryClient()
  const [, setLocation] = useLocation()
  const toast = useToast()

  const handleGoogleLoginSuccess = async (response: CredentialResponse) => {
    try {
      setIsLoading(true)

      const resp = await api.post('/auth/login/google', {
        credential: response.credential,
        ref: 'login_page_in_dashboard',
        device: getDevice(),
        referrer: document.referrer,
      })

      queryClient.invalidateQueries()

      if (resp.data.data?.isNewUser) {
        setLocation('/welcome')
      }
    } catch (error: any) {
      setIsLoading(false)
      toast.error(
        error?.response?.data?.message ?? 'Something went wrong. Try again?'
      )
    }
  }

  const handleGoogleLoginError = () => {
    toast.error('Something went wrong. Try again?')
    setIsLoading(false)
  }

  return (
    <div className={s.container}>
      <a href="https://goto.app" target="_blank" rel="noopener noreferrer">
        <img
          src="https://my.g.to/logo.svg"
          width="36"
          height="36"
          alt="Goto Logo"
        />
      </a>
      <h1 className={s.title}>Sign in to Goto</h1>

      {isLoading ? (
        <Spinner />
      ) : (
        <GoogleLoginButton
          onSuccess={handleGoogleLoginSuccess}
          onError={handleGoogleLoginError}
          useOneTap={import.meta.env.PROD}
          shape="circle"
        />
      )}
    </div>
  )
}
